import React from 'react'
import { useSelector } from 'react-redux'
import { OrderActivityLog } from 'types/OrderActivityLog'
import userProfileCurrentSelector from 'State/Store/UserProfile/Selectors/UserProfileCurrent.selector'
import { List, Divider } from '@material-ui/core'
import ActivityLogItemComp from './ActivityLogItemComp'
import moment from 'moment'
import { getOrderActivityLogSubText } from '../utils/get-sub-text'
import { getOrderActivityLogPrimaryText } from '../utils/get-primary-text'

const LOG_SERVICE_ERROR_MESSAGE = `Something went wrong while fetching activity log.`
const EMPTY_MESSAGE = `This log will show any actions made to this order via Boral Connects.`
const PRIMARY_EMPTY_TEXT = `No activity yet`
export const ORDER_ACTIVITY_LOG_DATE_FORMAT = `DD/MM/YYYY`
export const ORDER_ACTIVITY_LOG_TIME_FORMAT = `hh:mm a`

interface Props {
  logList: OrderActivityLog[],
  errorOccured: boolean,
}

const ActivityLogItemContainerComp = (props: Props) => {
  const {
    logList = [],
    errorOccured,
  } = props
  const userProfile = useSelector(userProfileCurrentSelector)
  const isEmpty = logList.length === 0

  if (isEmpty) {
    const primaryText = PRIMARY_EMPTY_TEXT
    const subText = errorOccured ? LOG_SERVICE_ERROR_MESSAGE : EMPTY_MESSAGE
    return (
      <List>
        <Divider />
        <ActivityLogItemComp
          primaryText={primaryText}
          subText={subText}
        />
      </List>
    )
  }
  const renderList = () => {
    return (
      <React.Fragment>
      {
        logList.map((log: OrderActivityLog) => {
          const primaryText = getOrderActivityLogPrimaryText(log)
          const subText = getOrderActivityLogSubText(log, userProfile)
          const dateText = moment(log.createdDate).format(ORDER_ACTIVITY_LOG_DATE_FORMAT)

          return (
            <div key={log.createdDate}>
              <ActivityLogItemComp
                primaryText={primaryText}
                subText={subText}
                dateText={dateText}
              />
            </div>
          )
        })
      }
      </React.Fragment>
    )
  }
  return (
    <List>
      <Divider />
      { renderList() }
    </List>
  )
}

export default ActivityLogItemContainerComp
